<template>
  <div class="rounded border overflow-hidden">
    <b-table-simple borderless class="mb-0" responsive>
      <b-thead>
        <b-tr>
          <b-th style="width: 1%">No</b-th>
          <b-th style="width: 30%">{{ this.lodash.startCase(this.$t("additional_fees.name")) }}</b-th>
          <b-th class="text-end" style="width: 40%">{{ this.lodash.startCase(this.$t("additional_fees.total")) }}</b-th>
          <b-th style="width: 10%">{{
              this.lodash.startCase(this.$t('unloads.additional_fees.is_markup_margin_item'))
            }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
            v-for="(value, index) in items"
            :key="index"
            :style="{
            '--bs-table-accent-bg': index %2 === 0 ? 'white' : '#f8fafc'
          }"
        >
          <b-td class="align-middle">{{ index + 1 }}</b-td>
          <b-td>{{ value.name }}</b-td>
          <b-td class="text-end">{{ $numeral(value.total).format("$ 0,0.[00]") }}</b-td>
          <b-td class>{{ lodash.upperFirst(value.is_markup_margin_item ? $t('yes') : $t('no')) }}</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  props: {
    saleOrder: Object,
    items: Array,
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  thead,
  tfoot {
    tr {
      --bs-table-accent-bg: #f8fafc;
    }
  }

  .table-striped > tbody > tr:nth-of-type(odd) {
    // --bs-table-accent-bg: white;
  }

  .table-striped > tbody > tr:nth-of-type(even) {
    // --bs-table-accent-bg: #f8fafc;
  }
}
</style>
